import { getEnvBadgeConfig as getEnvBadgeConfigBase } from '@pesto/ui/components/EnvBadge';

const PC_CLASS_BY_LABEL = {
  Local: 'border-accent/30 bg-accent/15 text-accent hover:bg-accent/20',
};

const SIMULATED_PURCHASE_ENV_LABELS: ReadonlySet<string> = new Set(['Dev', 'Local']);

export const getEnvBadgeConfig = () => getEnvBadgeConfigBase({ classNameByLabel: PC_CLASS_BY_LABEL });

export const isSimulatedPurchaseEnv = () => SIMULATED_PURCHASE_ENV_LABELS.has(getEnvBadgeConfig()?.label ?? '');
